import { Flex, Tabs, Card, Typography } from 'antd';
import { User, Wallet } from '@phosphor-icons/react';
import { useUserInfo } from '~/hooks/useUserInfo';
import VipComponent from './SVipPay';
import PluginComponent from './PluginPay';
import BalanceComponent from '~/pages/BalanceLog';
import ServerQRcode from '~/components/ServerQRcode';

import './index.less';
import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '~/context/AuthContext ';
import { useSEO } from '~/hooks/useSEO';
import { RECHARGE_SEO } from '~/seo/site';
import Pricing from './Pricing';
import { formatAmount, getVipExpireShow, getVipInfo } from '~/utils/function';
import { useSearchParams } from 'react-router-dom';
import { formatToDateTimeMin } from '~/utils/date';

export enum PackagesTabKey {
  VIP = 'vip',
  PLUGIN = 'plugin',
  CONSUMPTION = 'consumption',
  PRICING = 'pricing',
}

const Packages = () => {
  useSEO(RECHARGE_SEO);

  useUserInfo();
  const { userInfo, fetchUserInfo } = useAuth();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(PackagesTabKey.VIP);

  const tabItems = useMemo(() => {
    return [
      {
        key: PackagesTabKey.VIP,
        label: '会员购买',
        children: <VipComponent show={activeTab === PackagesTabKey.VIP} />,
      },
      {
        key: PackagesTabKey.PLUGIN,
        label: '积分充值',
        children: <PluginComponent show={activeTab === PackagesTabKey.PLUGIN} />,
      },
      {
        key: PackagesTabKey.CONSUMPTION,
        label: '消费明细',
        children: <BalanceComponent isTabItem={true} />,
      },
      {
        key: PackagesTabKey.PRICING,
        label: '计费标准',
        children: <Pricing />,
      },
    ];
  }, [activeTab]);

  const vipInfo = useMemo(() => {
    return getVipInfo(userInfo?.vipLevel as number);
  }, [userInfo?.vipLevel]);

  useEffect(() => {
    const type = searchParams.get('type');
    if (type) {
      setActiveTab(type as PackagesTabKey);
    }
  }, [searchParams]);

  useEffect(() => {
    if (userInfo?.id) {
      fetchUserInfo(userInfo.id!);
    }
  }, [userInfo?.id]);

  return (
    <div className="packages-page zt-page">
      <Flex className="zt-container" vertical gap={16}>
        <div className="service-info-section">
          <Flex className="service-banner" justify="space-between" align="center">
            <div className="packages-user-profile">
              <Flex className="packages-user-avatar-container" align="center" vertical gap={12}>
                <div className="packages-user-avatar">
                  <User weight="fill" size={32} />
                  <div className={`user-level-badge ${vipInfo.class}`}>{vipInfo.text}</div>
                </div>
                <div className="packages-user-id">
                  ID: {userInfo?.id || '-'}
                  <Typography.Text
                    copyable={{ text: userInfo?.id }}
                    className="ml-1 packages-user-id-copy"
                  />
                </div>
              </Flex>
              <Flex className="packages-user-info" vertical gap={8}>
                <div className="packages-user-name">
                  <span className="packages-user-name-label">用户名：</span>
                  {userInfo?.name || '未登录'}
                </div>
                <div className="packages-user-vip-expire mb-1">
                  会员有效期：{getVipExpireShow(userInfo)}
                </div>
                <div className="packages-user-balance-wrapper">
                  <div className="packages-user-balance-header">
                    <Wallet weight="fill" />
                    <span>积分余额：</span>
                    <span className="packages-amount-value">
                      {formatAmount(userInfo?.points || 0)}
                    </span>
                  </div>
                </div>
              </Flex>
            </div>
            <Flex justify="flex-end" align="center" gap={16}>
              <div className="service-highlight">
                <div className="service-text">
                  <span className="service-title">专属客服福利</span>
                  <span className="service-desc">
                    联系客服享受<span className="text-amber-300">更多</span>优惠
                  </span>
                  <span className="service-extra">充值越多送的越多</span>
                </div>
              </div>
              <div className="service-qrcode-wrapper">
                <ServerQRcode />
              </div>
            </Flex>
          </Flex>
          <div className="service-bg-effects">
            <div className="service-glow"></div>
            <div className="service-particles"></div>
          </div>
          <div className="service-yuan-bg"></div>
        </div>
        <Card className="packages-content">
          <Tabs
            activeKey={activeTab}
            onChange={(key) => setActiveTab(key as PackagesTabKey)}
            items={tabItems}
            className="packages-tabs"
            size="large"
          />
        </Card>
      </Flex>
    </div>
  );
};

export default Packages;
